import styles from './licenses.jcss'
import translate from '../../core/translate'
import moment from 'moment'
import { cn } from 'ethcss'
import helpers from '../../core/helpers'
import React from 'react'
import { colors, palette } from '../../theme'
import Icon from '../../blocks.simple/icon/icon'
import { changeLocation, routes } from '../../features/routes'
import { getURLSearchParamsString } from '../../features/routes/utils'
import AnimationWrapper from 'blocks.app/animationWrapper/animationWrapper'

export const getBackgroundColor = (license: any) => {
    if (!license.activeQ) return palette.neutral[400]
    if (license.licenseType === 'purchase') return palette.brandBlue.main
    if (license.giftQ) return colors.gift
    return palette.success.main
}

const getLicenseType = (type: string) => {
    if (!type) return ''

    return translate(type)
}

const isFutureStartLicense: any = (
    createdAt: string,
    startedAt: string,
    notExpiredQ: boolean,
    startedQ: boolean,
    deletedQ: boolean
) => {
    if (
        helpers.dateDifference(createdAt) < helpers.dateDifference(startedAt) &&
        !startedQ &&
        notExpiredQ &&
        !deletedQ
    ) {
        return true
    }
    return false
}

const viewLinkedDevices = (id: number) => {
    changeLocation({
        pathname: `/${routes.displays.path}`,
        search: getURLSearchParamsString({
            displays__filterList: `[{"name":"licenseId","type":"select","options":[{"value":${id},"label":"${id}","selected":true}]}]`,
        }),
    })
}

const getDaysLeftStatus = (license: any) => {
    const days = moment(license.expiredAt).diff(moment(), 'days')

    return !isNaN(days) && days >= 0 ? days + 1 : 0
}

export const License = ({ license }: any) => {
    return (
        <AnimationWrapper>
            <div className={cn(styles.licensesRow)} style={{ backgroundColor: getBackgroundColor(license) }}>
                <div className={cn(styles.licensesCol, styles.licensesCol_1)}>
                    <table>
                        <tr>
                            <td>
                                {translate('licenseIdN')}: {license.licenseId}
                            </td>
                            <td>{/*{translate('purchaseId')}: {license.purchaseId}*/}</td>
                        </tr>
                        <tr>
                            <td>{translate('licenseType')}:</td>
                            <td>{getLicenseType(license.licenseType)}</td>
                        </tr>
                        <tr>
                            <td>{translate('startDate')}:</td>
                            <td>{moment(license.startedAt).format('DD.MM.YYYY')}</td>
                        </tr>
                        <tr>
                            <td>{translate('endDate')}:</td>
                            <td>
                                {license.expiredAt
                                    ? moment(license.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </td>
                        </tr>
                    </table>
                </div>
                <div className={cn(styles.licensesCol, styles.licensesCol_2)}>
                    {license.deletedQ ? (
                        <div style={{ color: colors.black }}>{translate('licenseRevoked')}</div>
                    ) : !license.activeQ ? (
                        <div style={{ color: colors.black }}>{translate('licenseCompleted')}</div>
                    ) : (
                        <>
                            <div className={styles.daysLeft}>{translate('daysLeft')}</div>
                            <div className={styles.daysLeftCount}>
                                {license.expiredAt ? getDaysLeftStatus(license) : <Icon type={'infinityN'} size={30} />}
                            </div>
                        </>
                    )}
                </div>
                <div className={cn(styles.licensesCol, styles.licensesCol_3)}>
                    <div className={styles.tariffWrapper}>
                        <div className={styles.tariffTitle}>{translate('tariff')}</div>
                        <div className={styles.tariffName}>{license.rateType ? translate(license.rateType) : '—'}</div>
                    </div>
                    <div className={styles.details}>
                        <div className={styles.detailsAvailableLicenses}>
                            <div className={styles.availableTitle}>{translate('licensesAvailable')}</div>
                            <div className={styles.availableCount}>{license.devicesCount}</div>
                        </div>
                        <div className={styles.detailsUsedLicenses}>
                            <div className={styles.usedTitle}>{translate('isUsed')}</div>
                            <div className={styles.usedCount}>
                                {license.devicesCount - license.vacantCount}{' '}
                                <span>
                                    {translate('of')} {license.devicesCount}
                                </span>
                            </div>
                        </div>
                        <div className={styles.detailsLinkedDevices}>
                            <div className={styles.usedTitle}>{translate('linkedDevices')}</div>
                            <div
                                className={cn(styles.viewDevices, !license.activeQ ? styles.disabled : '')}
                                style={{ color: getBackgroundColor(license) }}
                                onClick={() => {
                                    viewLinkedDevices(license.licenseId)
                                }}
                            >
                                {translate('viewN')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AnimationWrapper>
    )
}
